import React from "react";

// NavLinks.js
export default function NavLinks({ links, onLinkClick, onHover, onLeave }) {
  return (
    <ul className="nav-links">
      {links.map((href) => (
        <li key={href}>
          <a
            href={href}
            onMouseEnter={onHover ? () => onHover(href) : undefined}
            onMouseLeave={onLeave ? onLeave : undefined}
            onClick={onLinkClick}
          >
            {href.replace(/^\/?#/, "").toUpperCase()}
          </a>
        </li>
      ))}
    </ul>
  );
}
